import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/dist/client';
import B2BTheme from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { ThdAnalytics } from '@thd-olt-component-react/thd-analytics';
import { whyDidYouRender } from '../wdyr';
import { App } from './App';
import { getRoutes } from './routes';
import { getDataObject } from './server-utils';
import { ddoInit, ddoEventInit, initializePageAnalytics } from './analytics';

ThdAnalytics.init();
NewRelicBridge.init();
whyDidYouRender.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext({
    opts: {
      federation: true,
    },
  });
  client.setExperienceRoutes(getRoutes());
  const dataObject = await getDataObject(client, 561029);
  if (client.customer.type === 'b2b') {
    client.setTheme({ name: 'b2b', template: B2BTheme });
  }

  if (!window.digitalData) {
    window.digitalData = {};
  }
  window.ddoInit = ddoInit;
  window.ddoEventInit = ddoEventInit;

  initializePageAnalytics({
    pageName: 'kitchen estimator',
    pageType: 'tool:kitchen estimator:calculator',
    omnitureInfo: {
      primaryCategory: 'kitchen',
      subCategory1: 'kitchen estimator',
    },
    storeInfo: client.store,
  });

  client.render(<App prefetchPip={client.featureSwitches.prefetchPip} productPodHoverDelay={client.featureSwitches.productPodHoverDelay} data={dataObject} />);
});
